import { Grid } from '@mui/material';
import { FormikErrors, FormikTouched } from 'formik';
import { TypeInitiative } from 'practice/constants/practice-management-step';
import { memo } from 'react';
import { PmiTextField } from 'shell/components/shared/text-field';

export interface PrintComunicationVM {
  reason?: string;
  note?: string;
  typeInitiative?: string; // utile per i controlli
}

interface AccordionPrintComunicationFormProps {
  disabled?: boolean;
  values?: PrintComunicationVM;
  errors?: FormikErrors<PrintComunicationVM>;
  touched?: FormikTouched<PrintComunicationVM>;
  onChange: (
    key: keyof PrintComunicationVM,
    value: PrintComunicationVM[keyof PrintComunicationVM]
  ) => void;
}

const AccordionPrintComunicationFormComponent = ({
  values,
  onChange,
  touched,
  errors,
}: AccordionPrintComunicationFormProps): React.ReactElement => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <PmiTextField
          id="reason"
          label="Motivo *"
          aria-label="motivo"
          fullWidth
          multiline
          rows={7}
          inputProps={{
            maxLength: '4000',
          }}
          onChange={(event) => {
            onChange('reason', event.target.value);
          }}
          value={values?.reason || ''}
          error={touched?.reason && Boolean(errors?.reason)}
          helperText={errors?.reason}
        />
      </Grid>
      <Grid item xs={12}>
        <PmiTextField
          id="note"
          label={
            values?.typeInitiative === TypeInitiative.Anpr
              ? 'Nota per il cittadino *'
              : 'Note Operatore'
          }
          aria-label={
            values?.typeInitiative === TypeInitiative.Anpr
              ? 'Nota per il cittadino'
              : 'Note Operatore'
          }
          fullWidth
          multiline
          rows={5}
          inputProps={{
            maxLength: '240',
          }}
          onChange={(event) => {
            onChange('note', event.target.value);
          }}
          value={values?.note || ''}
          error={touched?.note && Boolean(errors?.note)}
          helperText={errors?.note}
        />
      </Grid>
    </Grid>
  );
};

AccordionPrintComunicationFormComponent.displayName = 'Accordion end practice form component';

const AccordionPrintComunicationForm = memo(AccordionPrintComunicationFormComponent);

export default AccordionPrintComunicationForm;
